import { render } from "./DialogScreenBGColor.vue?vue&type=template&id=03c2f8b1"
import script from "./DialogScreenBGColor.vue?vue&type=script&lang=js"
export * from "./DialogScreenBGColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__